import { BuyerOptionPresetStatus, IdNamePair, OptionGroupDto, OptionItemDto } from '@/types';
import { OptionPresetImageDto } from '@/services/option-preset/option-preset-image/option-preset-image.types';
import { OptionPresetWithItemsDto, OptionPresetDto } from '../option-preset.types';
import { OptionPresetItemDto, PresetItemUpdateDto } from '../option-preset-item/option-preset-item.types';

export interface OptionPresetGroupDto {
    id: number;
    projectId: number;
    name: string;
    description: string;
    forceSelection: boolean;
    styleOptionsFree: boolean;
    createDate: Date | string | null;
    createdByUser: IdNamePair;
    legacyMode: boolean;
    status: BuyerOptionPresetStatus;
    sortOrder: number;
    presetCount: number;
    images: OptionPresetImageDto[];
    type: OptionPresetGroupType;
    roomIds: number[];
    projectDeadlineId: number | null;
    hasConnectedOptions: boolean;
}

export interface OptionPresetGroupWithItemsDto extends OptionPresetGroupDto {
    presets: OptionPresetWithItemsDto[];
}

export interface OptionPresetGroupUpdateOptions {
    projectId: number;
    name: string;
    description: string;
    forceSelection: boolean;
    styleOptionsFree: boolean;
    legacyMode: boolean;
    type: OptionPresetGroupType;
    roomIds?: number[];
    projectDeadlineId?: number | null;
}

export enum OptionPresetGroupType {
    Main = 'Main',
    Room = 'Room',
}

// Single-request payload for the style/preset matrix page: the styles (presets), the option groups in
// scope, all their option items, and the existing preset-item linkage. Mirrors the backend OptionPresetMatrixDto.
export interface OptionPresetMatrixDto {
    presets: OptionPresetDto[];
    groups: OptionGroupDto[];
    items: OptionItemDto[];
    presetItems: OptionPresetItemDto[];
}

// One style's batch of changes sent on Save. Reuses the existing Linked/Unlinked/Default deltas.
export interface PresetItemsChangeSet {
    presetId: number;
    items: PresetItemUpdateDto[];
}
